const ATTRIBUTION_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'qr_slug'] as const;
const MAX_ATTRIBUTION_LENGTH = 512;

export function getEventDeepLinkAttribution(queryParams?: Record<string, unknown> | null) {
  const attribution: Partial<Record<(typeof ATTRIBUTION_KEYS)[number], string>> = {};

  for (const key of ATTRIBUTION_KEYS) {
    const rawValue = queryParams?.[key];
    const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;
    if (typeof value !== 'string') continue;

    const normalized = Array.from(value.trim()).slice(0, MAX_ATTRIBUTION_LENGTH).join('');
    if (normalized) attribution[key] = normalized;
  }

  return attribution;
}
